import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './services/auth.guard';
import { MasterPageComponent } from './master-page/master-page.component';
const routes: Routes = [
  { path: '', component: LoginComponent  },
  { path: 'login', component: LoginComponent },
  {
    path: '', component: MasterPageComponent, children: [
      { path: 'ordersmanagement', loadChildren: () => import('src/app/ordersmanagement/ordersmanagement.module').then(m => m.OrdersmanagementModule) },
      { path: 'samplesmanagement', loadChildren: () => import('src/app/samplesmanagement/samplesmanagement.module').then(m => m.SamplesmanagementModule) },
      { path: 'financials', loadChildren: () => import('src/app/financials/financials.module').then(m => m.FinancialsModule) }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
